import { render } from "./ProfileTabs.vue?vue&type=template&id=143a349a&ts=true"
import script from "./ProfileTabs.vue?vue&type=script&lang=ts"
export * from "./ProfileTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__